import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuWide = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 41,
	height: 11,
	viewBox: "0 0 41 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("line", {
			x1: 1,
			y1: 1,
			x2: 40,
			y2: 1,
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 1,
			y1: 10,
			x2: 40,
			y2: 10,
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgMenuWide);
export { ForwardRef as ReactComponent };
